import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_User_Interface, User_Interface } from 'src/app/Interface/User_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { FundsService } from 'src/app/Service/Funds/Funds.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-FundsList',
  templateUrl: './FundsList.component.html',
  styleUrls: ['./FundsList.component.scss']
})
export class FundsListComponent implements OnInit {

  Token: string = ""
  Filter_Name: string = ""
  Filter_Familly: string = ""
  Filter_Username: string = ""
  page: number = 0;
  Procssing: boolean = false

  modalRef_Delete: any;

  constructor(
    private Funds_Service: FundsService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    public router: Router,
    private modalService: BsModalService
  ) { }


  DataList_User: Array<User_Interface> = []
  Data_Seleted_Delete: User_Interface = Empty_User_Interface()

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');

    this.Nav_Service.CheckValidPage(this.Token, 1149).subscribe(
      data => {
        this.ReadData_User()
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_User() {
    this.Procssing = true
    this.Funds_Service.GetRecord(this.Token).subscribe(
      data => {
        this.DataList_User = data
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }


  //#region Funds Form

  Selected_Funds_Record: User_Interface
  Selected_Funds_Record_Switcher: string = 'List'
  Set_List_Funds_View() {
    this.Selected_Funds_Record_Switcher = 'List'
  }

  Set_Form_Funds_View(item: User_Interface, Switcher: string) {
    this.Selected_Funds_Record = item
    this.Selected_Funds_Record_Switcher = Switcher
  }

  //#endregion


  Change_Filter() {
    this.page = 0
  }

  exportexcel_Funds(): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, "BehfaFund.xlsx");

  }

}
